module.exports = [
	{
		"country": "United States",
		"dollars": 31.08,
		"fill": "url(#us-flag)"
	},
	{
		"country": "United Kingdom",
		"dollars": 18.7,
		"fill": "url(#gb-flag)"
	},
	{
		"country": "Germany",
		"dollars": 17.78,
		"fill": "url(#de-flag)"
	},
	{
		"country": "Japan",
		"dollars": 9.32,
		"fill": "url(#jp-flag)"
	},
	{
		"country": "France",
		"dollars": 9.23,
		"fill": "url(#fr-flag)"
	},
	{
		"country": "Sweden",
		"dollars": 7.09,
		"fill": "url(#se-flag)"
	},
	{
		"country": "Netherlands",
		"dollars": 5.81,
		"fill": "url(#nl-flag)"
	},
	{
		"country": "United Arab Emirates",
		"dollars": 4.39,
		"fill": "url(#ae-flag)"
	},
	{
		"country": "Canada",
		"dollars": 4.29,
		"fill": "url(#ca-flag)"
	},
	{
		"country": "Norway",
		"dollars": 4.28,
		"fill": "url(#no-flag)"
	},
	{
		"country": "Turkey",
		"dollars": 3.91,
		"fill": "url(#tr-flag)"
	},
	{
		"country": "Italy",
		"dollars": 3.84,
		"fill": "url(#it-flag)"
	},
	{
		"country": "Switzerland",
		"dollars": 3.54,
		"fill": "url(#ch-flag)"
	},
	{
		"country": "Australia",
		"dollars": 3.22,
		"fill": "url(#au-flag)"
	},
	{
		"country": "Denmark",
		"dollars": 2.57,
		"fill": "url(#dk-flag)"
	},
	{
		"country": "South Korea",
		"dollars": 1.91,
		"fill": "url(#kr-flag)"
	},
	{
		"country": "Belgium",
		"dollars": 1.89,
		"fill": "url(#be-flag)"
	},
	{
		"country": "Spain",
		"dollars": 1.6,
		"fill": "url(#es-flag)"
	},
	{
		"country": "Finland",
		"dollars": 1.29,
		"fill": "url(#fi-flag)"
	},
	{
		"country": "Austria",
		"dollars": 1.21,
		"fill": "url(#at-flag)"
	},
	{
		"country": "Russia",
		"dollars": 1.14,
		"fill": "url(#ru-flag)"
	},
	{
		"country": "Ireland",
		"dollars": 0.72,
		"fill": "url(#ie-flag)"
	},
	{
		"country": "Poland",
		"dollars": 0.44,
		"fill": "url(#pl-flag)"
	},
	{
		"country": "New Zealand",
		"dollars": 0.44,
		"fill": "url(#nz-flag)"
	},
	{
		"country": "Luxembourg",
		"dollars": 0.36,
		"fill": "url(#lu-flag)"
	},
	{
		"country": "Portugal",
		"dollars": 0.31,
		"fill": "url(#pt-flag)"
	},
	{
		"country": "Greece",
		"dollars": 0.28,
		"fill": "url(#gr-flag)"
	},
	{
		"country": "Israel",
		"dollars": 0.21,
		"fill": "url(#il-flag)"
	},
	{
		"country": "Czech Republic",
		"dollars": 0.2,
		"fill": "url(#cz-flag)"
	},
	{
		"country": "Hungary",
		"dollars": 0.15,
		"fill": "url(#hu-flag)"
	},
	{
		"country": "Slovak Republic",
		"dollars": 0.09,
		"fill": "url(#sk-flag)"
	},
	{
		"country": "Slovenia",
		"dollars": 0.06,
		"fill": "url(#si-flag)"
	},
	{
		"country": "Croatia",
		"dollars": 0.05,
		"fill": "url(#hr-flag)"
	},
	{
		"country": "Iceland",
		"dollars": 0.04,
		"fill": "url(#is-flag)"
	},
	{
		"country": "Lithuania",
		"dollars": 0.04,
		"fill": "url(#lt-flag)"
	},
	{
		"country": "Estonia",
		"dollars": 0.03,
		"fill": "url(#ee-flag)"
	},
	{
		"country": "Latvia",
		"dollars": 0.02,
		"fill": "url(#lv-flag)"
	},
	{
		"country": "Malta",
		"dollars": 0.01,
		"fill": "url(#mt-flag)"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/Blog/DataIsBeautiful/developmentAidByCountry.json
// module id = 297
// module chunks = 0